module.exports = __webpack_public_path__ + "img/t2_m.711aad2e.png";